// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = true; // Sostituire con la logica di autenticazione effettiva
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
